// const API = "https://bomapi.azurewebsites.net/api";
const API = process.env.REACT_APP_API_URL;
//
// POST Routes
export const API_URL = `${API}`;

export const SIGNUP = `${API}/users`;
export const CHANGE_PASSWORD = `${API}/users/resetPassword`;
export const LOGIN = `${API}/login`;
export const LOGOUT = `${API}/logout`;
export const FORGOT_PASSWORD = `${API}/users/forgotPassword`;
export const CUSTOMERS = `${API}/customers`;
export const BOM_PARSE = `${API}/bomProcessing`;
export const GET_QUOTE = `${API}/getQuotes`;
export const GET_BOMLINES_SCRAPPED_PERCENT = `${API}/getBomLinesScrappedPercent`;
export const ADD_USER = `${API}/users`;
export const SAVE_PARTS_REVS = `${API}/partRevisions`;
export const UPDATE_VENDOR_LIST = `${API}/distributors`;
export const STORE_RESULTANT_BOM = `${API}/storeResultantBom`;
export const ADD_BOMCHECKLIST = `${API}/bomchecklists`;
export const ADD_ATTRITION = `${API}/attritions`;
export const INSERT_ATTRITION_LIST = `${API}/attritions/insert-list`;
export const CHECK_ATTRITION_PACKAGES = `${API}/attritions/check-packages`;
export const ADD_PACKAGE_LEAD_TYPE = `${API}/packageLeadTypes`;
export const ADD_SYSTEM_SETTING = `${API}/systemSettings`;

// GET Routes
export const GET_USERS = `${API}/users`;
export const GET_USER = `${API}/users/:id`;
export const GET_ROLES = `${API}/roles`;
export const COLUMNS_LIST = `${API}/columns`;
export const COLUMN_ALIASES = `${API}/columnAliases`;
export const DISTRIBUTORS_LIST = `${API}/distributors`;
export const CUSTOMERS_LIST = `${API}/customers`;
export const PARTS_REVS_LIST = `${API}/partRevisions`;
export const BOM_HISTORY = `${API}/boms`;
export const GET_FILE = `${API}/file`;
export const SHARE_BOM = `${API}/shareBom`;
export const GET_BOMCHECKLISTS = `${API}/bomchecklists`;
export const DIGIKEY_ENRICH = `${API}/digikey/enrich`;
export const DIGIKEY_ENRICHMENT_PROGRESS = `${API}/digikey/enrichment-progress`;
export const DIGIKEY_SUBSTITUTES = `${API}/digikey/substitutes`;
export const DIGIKEY_VIEW_OPTIONS = `${API}/digikey/view-options`;
export const DIGIKEY_SAVE_OBSOLETE_ALTERNATES = `${API}/digikey/obsolete-alternates`;
export const DIGIKEY_REFRESH_DETAILS = `${API}/digikey/refresh-details`;
export const DIGIKEY_PART_SUGGESTIONS = `${API}/digikey/part-suggestions`;
export const BOM_ISSUE_REPORT = (bomId) => `${API}/boms/${bomId}/issue-report`;
export const GET_ATTRITIONS = `${API}/attritions`;
export const GET_PARTS_CATALOG = `${API}/parts/catalog`;
export const PARTS_REFRESH_QUEUE = `${API}/parts/refresh-queue`;
export const GET_PACKAGE_LEAD_TYPES = `${API}/packageLeadTypes`;
export const GET_SYSTEM_SETTINGS = `${API}/systemSettings`;

// UPDATE Routes
export const UPDATE_USER = `${API}/users/`;
export const UPDATE_BOMCHECKLIST = `${API}/bomchecklists`;
export const UPDATE_ATTRITION = `${API}/attritions`;
export const UPDATE_PACKAGE_LEAD_TYPE = `${API}/packageLeadTypes`;
export const UPDATE_SYSTEM_SETTING = `${API}/systemSettings`;

// DELETE Routes
export const DELETE_USER = `${API}/user`;
export const DELETE_BOMCHECKLIST = `${API}/bomchecklists`;
export const DELETE_ATTRITION = `${API}/attritions`;
export const DELETE_PART = `${API}/parts`;
export const DELETE_PACKAGE_LEAD_TYPE = `${API}/packageLeadTypes`;
export const DELETE_SYSTEM_SETTING = `${API}/systemSettings`;
